import { Guid } from 'guid-typescript';
import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from './authentication.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
    private sessionUserService;
    private sessionUserRole;

    constructor(
        private router: Router,
        private authenticationService: AuthenticationService
    ) { }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            const sessionUser = this.authenticationService.currentUserValue;

            // TODO: REMOVE THIS BLOCK AFTER DATA UPDATE (Lockdown for admin only)
            // if (sessionUser && sessionUser.userName !== 'admin@edulinkin.com') {
            //     //alert('System is under data updating for the next 24 hours. Please try again later.');
            //     this.authenticationService.logout();
            //     reject();
            //     return;
            // }
            // END OF BLOCK

            if (sessionUser && sessionUser.token && sessionUser.roles && sessionUser.roles.length > 0 && sessionUser.services && sessionUser.services.length > 0) {

                // Service
                this.sessionUserService = localStorage.getItem('currentUserService') || sessionUser.services[0].service.id.toString();
                localStorage.setItem('currentUserService', this.sessionUserService.toString());
                localStorage.setItem('currentUserSubscription', sessionUser.services[0].service.subscriptionId.toString());

                // Profile (from profiles array filtered by serviceId)
                let currentProfileId = localStorage.getItem('currentProfileId');
                const profilesForService = (sessionUser.profiles || []).filter(p => p.serviceId.toString() == this.sessionUserService?.toString());
                if (!currentProfileId || profilesForService.findIndex(p => p.profileId.toString() == currentProfileId?.toString()) == -1)
                    currentProfileId = profilesForService[0]?.profileId?.toString();
                if (currentProfileId)
                    localStorage.setItem('currentProfileId', currentProfileId.toString());

                // Role (filtered by serviceId + profileId)
                let Role = sessionUser.roles.filter(r =>
                    r.serviceId.toString() == this.sessionUserService?.toString() &&
                    r.profileId.toString() == currentProfileId?.toString() &&
                    r.id.toString() == route.queryParams['RoleId']?.toString()
                );

                if (Role.length == 0) {
                    Role = sessionUser.roles.filter(r =>
                        r.serviceId.toString() == this.sessionUserService?.toString() &&
                        r.profileId.toString() == currentProfileId?.toString() &&
                        r.id.toString() == localStorage.getItem('currentUserRoleId')?.toString()
                    );
                }

                if (Role.length == 0) {
                    Role = sessionUser.roles.filter(r =>
                        r.serviceId.toString() == this.sessionUserService?.toString() &&
                        r.profileId.toString() == currentProfileId?.toString()
                    );
                }

                if (Role.length > 0) {
                    this.sessionUserRole = Role[0].name;
                    localStorage.setItem('currentUserRole', this.sessionUserRole);
                    localStorage.setItem('currentUserRoleId', Role[0].id.toString());
                }

                const pathSegments = (state?.url || '')
                    .split('?')[0]
                    .split('/')
                    .filter(segment => !!segment)
                    .slice(0, 2);
                const screenName = `/${pathSegments.join('/')}`;
                this.authenticationService.handlePermission(screenName).subscribe(hasPermission => {
                    if (!hasPermission && state.url !== '/') {
                        this.router.navigate(['/']);
                    }
                    resolve(hasPermission);
                });
            }
            else {
                this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
                reject();
            }
        });
    }
}